export const findNextTen = (value: number) => Math.ceil(value / 10) * 10;
